import axios from "axios";

const accountListReq = async (idToken, params) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      params: params,
    };
    const response = await axios.get("account/list/", config);
    return response.data;
  } catch (error) {
    console.error("Error during accountList request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const accountLoginIdsListReq = async (idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get("account/user-account-names/", config);
    return response.data;
  } catch (error) {
    console.error("Error during accountLoginIdsList request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};

const getPaymentHistoryList = async (idToken, params) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      params: params,
    };
    const response = await axios.get("payment/payment-history/", config);
    return response.data;
  } catch (error) {
    console.error("Error during accountList request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const getCommissionList = async (idToken, params) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      params: params,
    };
    const response = await axios.get("affiliates/commission-history/", config);
    return response.data;
  } catch (error) {
    console.error("Error during commission request:", error);
    throw error;
  }
};
const getMarketDataSubscription = async (idToken, params) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get(
      `payment/get-market-data-level/?platform=${params}`,
      config,
    );
    return response.data;
  } catch (error) {
    console.error("Error during accountList request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const getMarketDataMapping = async (idToken, params) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get(
      `payment/get-market-data-level-mapping/?platform=${params}`,
      config,
    );
    return response.data;
  } catch (error) {
    console.error("Error during accountList request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const getSubscription = async (idToken, params) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      params: params,
    };
    const response = await axios.get("subscription/list/", config);
    return response.data;
  } catch (error) {
    console.error("Error during accountList request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const SubscriptionReq = async (data, idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.post("subscription/cancel/", data, config);
    return response;
  } catch (error) {
    console.error("Error during accountList request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};

const fundingEvalutionPlans = async () => {
  try {
    const response = await axios.get(`account/funding-evaluation/`);
    return response.data;
  } catch (error) {
    console.error("Error during account metrics request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};

const getBalanceChartRequest = async (idToken, loginId, params={}) => {
  try {
    let config = {
      headers: { Authorization: `Bearer ${idToken}` },

      params,
    };
    const response = await axios.get(
      `account/balance-equity/${loginId}/`,
      config,
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
const getAccountMetrics = async (loginId) => {
  try {
    const response = await axios.get(`account/metrics/${loginId}`);

    return response.data;
  } catch (error) {
    throw error;
  }
};

const getNewMaxLoss = async (login_id) => {
  try {
    const response = await axios.get(`account/account-meta-data/${login_id}/`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateAccountMetrics = async (login_id, data) => {
  try {
    const response = await axios.patch(
      `account/update-permission/${login_id}/`,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
const getPerformanceChartRequest = async (idToken, loginId) => {
  try {
    let config = {
      headers: { Authorization: `Bearer ${idToken}` },
    };
    const response = await axios.get(
      `account/performance-chart/${loginId}`,
      config,
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
const getAccountStats = async (idToken, login_id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get(
      `account/admin/insight-analysis/${login_id}`,
      config,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteAccount = async (data, idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.post(
      "account/user/delete-account/",
      data,
      config,
    );
    return response;
  } catch (error) {
    console.error("Error during deleteAccount request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const switchSubscription = async (data, idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.post(
      "subscription/switch-subscription/",
      data,
      config,
    );
    return response;
  } catch (error) {
    console.error("Error during switch subscription request:", error);
    throw error;
  }
};

export {
  accountListReq,
  getPaymentHistoryList,
  fundingEvalutionPlans,
  getMarketDataSubscription,
  getBalanceChartRequest,
  getPerformanceChartRequest,
  getSubscription,
  SubscriptionReq,
  accountLoginIdsListReq,
  getCommissionList,
  updateAccountMetrics,
  getAccountMetrics,
  getNewMaxLoss,
  getAccountStats,
  getMarketDataMapping,
  deleteAccount,
  switchSubscription,
};
